import React from "react";
import {
  compareArrays,
  filterAccountabilityAttrs,
  isStateFilled,
} from "../../../../utils/daily-accountability";
import AccountabilityCard from "../../../cards/profile-accountability";
import submit from "submit-form";
import ConfirmationModal from "../../ConfirmationModal";
import SvgIcon from "../../../SvgIcon";

const weekDays = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
const AddAccountabilityTemplate = ({
  template,
  athleteId,
  defaultTemplate,
  userToLoadInformation,
  organizationOwner,
  templateId,
}) => {
  let days = {};
  weekDays.forEach((day) => (days = { ...days, [day]: false }));
  const emptyItem = {
    title: "",
    description: "",
    days,
    editing: true,
  };

  const [adding, setAdding] = React.useState(false);
  const [changed, setChanged] = React.useState(false);
  const [canSubmit, setCanSubmit] = React.useState(false);
  const [templateName, setTemplateName] = React.useState(template?.name || "");
  const [isDefault, setIsDefault] = React.useState(
    (template && template?._id === defaultTemplate) || false
  );
  const [state, setState] = React.useState(template?.list || [emptyItem]);
  const [idToDelete, setIdToDelete] = React.useState(undefined); //this is to save the id to delete, and also open/close the delete modal

  const addItem = () => {
    setAdding(true);
    const newState = state.map((item) => {
      return { ...item, editing: false };
    });
    setState([...newState, emptyItem]);
  };

  const saveTemplateChanges = () => {
    const url = template
      ? `/actions/daily-accountability/add-template?templateId=${template._id}`
      : `/actions/daily-accountability/add-template`;
    submit(url, {
      method: "POST",
      body: {
        name: templateName,
        list: state.map((item) => filterAccountabilityAttrs(item)),
        isDefault,
        // if we are in an organization case, we need to send the organization owner id
        // to save the template at the owner level
        userToRequest: organizationOwner?._id || userToLoadInformation?._id,
      },
    });
  };
  const handleName = (e) => {
    setTemplateName(e.target.value);
  };
  const handleEditing = (i) => {
    setState(
      state.map((item, index) => {
        return i === index
          ? { ...item, editing: !item.editing }
          : { ...item, editing: false };
      })
    );
  };

  const removeItem = (id) => {
    setIdToDelete(id); // opening the modal sending the id to delete
  };

  const handleCancelDelete = () => {
    setIdToDelete(undefined);
  };

  const handleConfirmDelete = () => {
    if (template && !adding) {
      const newState = state.filter((item, i) => i !== idToDelete);
      submit(
        `/actions/daily-accountability/remove-item-template?templateId=${template._id}`,
        {
          method: "POST",
          body: {
            name: template.name,
            list: newState.map((item) => filterAccountabilityAttrs(item)),
            isDefault: template.isDefault,
            // if we are in an organization case, we need to send the organization owner id
            // to save the template at the owner level
            userToRequest: organizationOwner?._id || userToLoadInformation?._id,
          },
        }
      );
      setState(newState);
    } else setState(state.filter((item, i) => i !== idToDelete));
    setIdToDelete(undefined);
  };

  React.useEffect(() => {
    compareArrays(template?.list || [], state) ||
    template?.name !== templateName
      ? setChanged(true)
      : setChanged(false);
    if (isStateFilled(state)) setCanSubmit(true);
    else setCanSubmit(false);
  }, [template?.list, state, templateName]);
  // const Header = () => {
  //   return(

  //   )
  // }
  return (
    <div className="Modal-Box add-accountability-template-modal">
      <a href={`/actions/refresh?modal=&templateId=`} className="overlay" />
      <div className="box">
        <header>
          <h2 className="only-show-mobile">
            {templateId ? "Edit a Template" : "Add a Template"}
          </h2>
          <input
            className="input-template-title mobile-hidden"
            placeholder="ENTER TITLE HERE"
            value={templateName}
            name="name"
            onChange={handleName}
          ></input>
          <a
            href={`/actions/refresh?modal=&templateId=`}
            // className="close"
            role="button"
            data-button-type="tertiary"
            data-icon-only="true"
          >
            <img src="/img/new-icons/red-cross.svg" alt="dismiss" />
          </a>
        </header>
        <div className="body">
          <label className="force-only-show-mobile">
            <p className="p4">Template Name</p>
            <input
              name="name"
              className="input-template-title"
              placeholder="Enter title here"
              value={templateName}
              onChange={handleName}
            />
          </label>
          <ul>
            {state.map((item, i) => (
              <AccountabilityCard
                athleteId={athleteId}
                state={state}
                id={i}
                setState={setState}
                changeOrder={false}
                editing={item.editing || false}
                handleEditing={handleEditing}
                removeItem={() => removeItem(i)}
              />
            ))}
          </ul>
          <ConfirmationModal
            isOpen={idToDelete !== undefined}
            title="Delete Accountability"
            contentText={`Are you sure you want to delete this Accountability? \n If you delete it, you won’t be able to recover the Accountability back.`}
            cancelButtonText="Cancel"
            cancelButtonAction={handleCancelDelete}
            confirmButtonText="Delete"
            confirmButtonAction={handleConfirmDelete}
            reduceSize={true}
            icon="delete"
          />
          {!templateId && (
            <div className="add-acc-new-footer-buttons">
              <button
                onClick={canSubmit ? addItem : null}
                className={canSubmit ? "acc-btn add-new" : "acc-btn disabld"}
                data-button-type="outline"
                disabled={canSubmit ? undefined : true}
              >
                Add New
              </button>
              <a
                href={`/actions/refresh?modal=&templateId=`}
                className=" only-show-mobile acc-btn add-new"
              >
                Cancel
              </a>
            </div>
          )}
        </div>
        <footer>
          <div onClick={() => setIsDefault(!isDefault)}>
            <SvgIcon
              src={`/img/new-icons/${isDefault ? "" : "un"}checked-square.svg`}
              noFilterOnLight={isDefault ? true : false}
            />
            <p className="p4">Set as default</p>
          </div>
          {
            <button
              onClick={changed && canSubmit ? saveTemplateChanges : null}
              data-button-type="primary"
              disabled={changed && canSubmit ? undefined : true}
              // className={
              //   changed && canSubmit ? "acc-btn save" : "acc-btn disabld"
              // }
            >
              Save
            </button>
          }
        </footer>
      </div>
    </div>
  );
};

export default AddAccountabilityTemplate;
